var map = {
  "./mobile/index": [
    "55512",
    9,
    "79118",
    "47387",
    "3199",
    "77996",
    "68454",
    "44944",
    "17189",
    "6532",
    "60878",
    "27716"
  ],
  "./desktop/IPLStatic": [
    "73247",
    9,
    "34579",
    "80640"
  ],
  "./desktop/index": [
    "18722",
    9,
    "76225",
    "62815",
    "85598",
    "47387",
    "3199",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "60878",
    "34579",
    "52352"
  ],
  "./desktop/index.js": [
    "18722",
    9,
    "76225",
    "62815",
    "85598",
    "47387",
    "3199",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "60878",
    "34579",
    "52352"
  ],
  "./mobile/index.js": [
    "55512",
    9,
    "79118",
    "47387",
    "3199",
    "77996",
    "68454",
    "44944",
    "17189",
    "6532",
    "60878",
    "27716"
  ],
  "./mobile/IPLStatic.js": [
    "45257",
    9,
    "6532",
    "8276"
  ],
  "./mobile": [
    "55512",
    9,
    "79118",
    "47387",
    "3199",
    "77996",
    "68454",
    "44944",
    "17189",
    "6532",
    "60878",
    "27716"
  ],
  "./desktop": [
    "18722",
    9,
    "76225",
    "62815",
    "85598",
    "47387",
    "3199",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "60878",
    "34579",
    "52352"
  ],
  "./desktop/": [
    "18722",
    9,
    "76225",
    "62815",
    "85598",
    "47387",
    "3199",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "60878",
    "34579",
    "52352"
  ],
  "./desktop/IPLStatic.js": [
    "73247",
    9,
    "34579",
    "80640"
  ],
  "./desktop/IPLStatic.scss": [
    "79873",
    7,
    "58617"
  ],
  "./mobile/": [
    "55512",
    9,
    "79118",
    "47387",
    "3199",
    "77996",
    "68454",
    "44944",
    "17189",
    "6532",
    "60878",
    "27716"
  ],
  "./mobile/IPLStatic": [
    "45257",
    9,
    "6532",
    "8276"
  ],
  "./mobile/IPLStatic.scss": [
    "99725",
    7,
    "92797"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
    return __webpack_require__.t(id, ids[1] | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 99294;
module.exports = __rspack_async_context;
